import { createFileRoute } from '@tanstack/react-router'

import { TenantJobsPage } from '@/pages/tenants/detail/TenantJobsPage'

export const Route = createFileRoute('/_authenticated/tenants/$id/jobs')({
  component: TenantJobsPage,
})
